import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import VueCookies from "vue-cookies";
import clienteService from "@/services/cliente";
import termosService from "@/services/termos";
import http from "@/plugins/axios";
import gtm from '@/plugins/gtm';
import vuetify from "@/plugins/vuetify";
import { make } from "vuex-pathify";
import * as Sentry from "@sentry/vue";
var state = {
  autenticado: false,
  identificador: localStorage.getItem("meLembreIdentificador"),
  preAutenticando: false,
  preAutenticacao: {},
  cliente: {},
  empresa: JSON.parse(localStorage.getItem("meLembreEmpresa") || "{}"),
  token: VueCookies.get("meLembreToken"),
  carregandoTema: true
};
var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  setEmpresaUrl: function setEmpresaUrl(state) {
    state.empresa.url_instancia = state.empresa.url_instancia.replace("localhost", window.location.hostname);
  },
  setCarregandoTema: function setCarregandoTema(state, payload) {
    state.carregandoTema = payload;
  },
  setCliente: function setCliente(state, dados) {
    state.cliente = dados;
  },
  setPreAutenticando: function setPreAutenticando(state, payload) {
    state.preAutenticando = payload;
  }
});
var actions = {
  preAutenticar: function () {
    var _preAutenticar = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, payload) {
      var rootState, commit, dispatch, carregaNps, inicio, resposta, dados, mensagens, params, duracao, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            rootState = _ref.rootState, commit = _ref.commit, dispatch = _ref.dispatch;
            commit("setPreAutenticando", true);
            console.debug("Pré-autenticando...");
            carregaNps = payload === null || payload === void 0 ? void 0 : payload.carregaNps;
            payload === null || payload === void 0 || delete payload.carregaNps;
            inicio = Math.round(performance.now());
            _context.p = 1;
            _context.n = 2;
            return clienteService.auth(payload);
          case 2:
            resposta = _context.v;
            dados = resposta.data || {};
            atualizarTema(dados.empresa.tema);
            commit("preAutenticacao", dados);
            commit("setCliente", _objectSpread(_objectSpread({}, dados.cliente), {}, {
              autosservico: dados.empresa.autosservico
            }));
            commit("empresa", dados.empresa);
            if (process.env.NODE_ENV != "production") {
              commit("setEmpresaUrl");
            }
            localStorage.setItem("meLembreEmpresa", JSON.stringify(dados.empresa));
            if (payload.identificador) {
              localStorage.setItem("meLembreIdentificador", payload.identificador);
              commit("identificador", payload.identificador);
            }
            http.apiCore.defaults.headers.common["Authentication-Token"] = dados.token;
            http.apiEmpresa.defaults.headers.common["Authentication-Token"] = dados.token;
            mensagens = 0;
            if (!dados.cliente.tem_email) mensagens++;
            // if (!dados.cliente.tem_whatsapp) mensagens++;
            if (!dados.cliente.tem_push) mensagens++;
            rootState.chat.mensagens = mensagens;
            Sentry.setContext("empresa", {
              nome: dados.empresa.nome
            });
            Sentry.setTag("empresa.nome", dados.empresa.nome);
            gtm.enviar({
              "event": "acessouEmpresa",
              "ml.empresa.nome": dados.empresa.nome
            });
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Não foi possível pré-autenticar.", _t);
            throw _t;
          case 4:
            _context.p = 4;
            commit("setCarregandoTema", false);
            if (carregaNps) {
              //Carrega pesquisa NPS
              params = {
                identificador: state.identificador
              };
              dispatch('nps/getNps', params, {
                root: true
              });
            }
            duracao = (Math.round(performance.now()) - inicio) / 1000;
            console.debug("Tempo de pré-autenticação:", duracao);
            commit("setPreAutenticando", false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    function preAutenticar(_x, _x2) {
      return _preAutenticar.apply(this, arguments);
    }
    return preAutenticar;
  }(),
  autenticar: function () {
    var _autenticar = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2, payload) {
      var rootState, commit, dispatch, carregaNps, inicio, resposta, dados, params, duracao, _state$empresa, _resposta, _dados, mensagens, _t2, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            rootState = _ref2.rootState, commit = _ref2.commit, dispatch = _ref2.dispatch;
            console.debug("Autenticando.");
            carregaNps = payload === null || payload === void 0 ? void 0 : payload.carregaNps;
            payload === null || payload === void 0 || delete payload.carregaNps;
            inicio = Math.round(performance.now());
            _context2.p = 1;
            _context2.n = 2;
            return clienteService.auth(payload);
          case 2:
            resposta = _context2.v;
            dados = resposta.data || {};
            http.apiCore.defaults.headers.common["Authentication-Token"] = dados.token;
            http.apiEmpresa.defaults.headers.common["Authentication-Token"] = dados.token;
            VueCookies.set("meLembreToken", dados.token);
            gtm.evento("logou");
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            console.error("Não foi possível autenticar.", _t2);
            throw _t2;
          case 4:
            _context2.p = 4;
            //Carrega pesquisa NPS
            if (carregaNps && state.identificador) {
              params = {
                identificador: state.identificador
              };
              dispatch('nps/getNps', params, {
                root: true
              });
            }
            duracao = (Math.round(performance.now()) - inicio) / 1000;
            console.debug("Tempo de autenticação:", duracao);
            return _context2.f(4);
          case 5:
            console.debug("Buscando as informações do usuário autenticado.");
            _context2.p = 6;
            _context2.n = 7;
            return clienteService.info();
          case 7:
            _resposta = _context2.v;
            _dados = _resposta.data || {};
            commit("autenticado", true);
            commit("setCliente", _objectSpread(_objectSpread({}, _dados), {}, {
              autosservico: (_state$empresa = state.empresa) === null || _state$empresa === void 0 ? void 0 : _state$empresa.autosservico
            }));
            mensagens = 0;
            if (!_dados.email) mensagens++;
            // if (!dados.whatsapp) mensagens++;
            if (!_dados.tem_push) mensagens++;
            rootState.chat.mensagens = mensagens;
            Sentry.setUser({
              id: _dados.id,
              email: _dados.email,
              username: _dados.nome
            });
            Sentry.setTag("cliente.documento", _dados.documento);
            gtm.enviar({
              "event": "identificouCliente",
              "ml.cliente.documento": _dados.documento,
              "ml.cliente.email": _dados.email,
              "ml.cliente.nome": _dados.nome
            });
            _context2.n = 9;
            break;
          case 8:
            _context2.p = 8;
            _t3 = _context2.v;
            console.error("Não foi possível buscar as informações do cliente.", _t3);
            throw _t3;
          case 9:
            _context2.p = 9;
            commit("setCarregandoTema", false);
            return _context2.f(9);
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[6, 8, 9, 10], [1, 3, 4, 5]]);
    }));
    function autenticar(_x3, _x4) {
      return _autenticar.apply(this, arguments);
    }
    return autenticar;
  }(),
  buscarInformacoes: function () {
    var _buscarInformacoes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
      var rootState, commit, _state$empresa2, resposta, dados, mensagens, _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            rootState = _ref3.rootState, commit = _ref3.commit;
            console.debug("Buscando as informações do usuário autenticado.");
            _context3.p = 1;
            _context3.n = 2;
            return clienteService.info();
          case 2:
            resposta = _context3.v;
            dados = resposta.data || {};
            commit("autenticado", true);
            commit("setCliente", _objectSpread(_objectSpread({}, dados), {}, {
              autosservico: (_state$empresa2 = state.empresa) === null || _state$empresa2 === void 0 ? void 0 : _state$empresa2.autosservico
            }));
            Sentry.setUser({
              id: dados.id,
              email: dados.email,
              username: dados.nome
            });
            Sentry.setTag("cliente.documento", dados.documento);
            gtm.enviar({
              "event": "identificouCliente",
              "ml.cliente.documento": dados.documento,
              "ml.cliente.email": dados.email,
              "ml.cliente.nome": dados.nome
            });
            mensagens = 0;
            if (!dados.email) {
              mensagens++;
            }

            // if (!dados.whatsapp) {
            //   mensagens++;
            // }

            if (!dados.tem_push) {
              mensagens++;
            }
            rootState.chat.mensagens = mensagens;
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t4 = _context3.v;
            console.error("Não foi possível buscar as informações do cliente.", _t4);
            throw _t4;
          case 4:
            _context3.p = 4;
            commit("setCarregandoTema", false);
            return _context3.f(4);
          case 5:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3, 4, 5]]);
    }));
    function buscarInformacoes(_x5) {
      return _buscarInformacoes.apply(this, arguments);
    }
    return buscarInformacoes;
  }(),
  logout: function logout(_ref4) {
    var commit = _ref4.commit;
    console.debug("Fazendo logout.");
    commit("autenticado", false);
    commit("setCliente", {});
    commit("empresa", {});
    commit("token", null);
    VueCookies.remove("meLembreToken");
    localStorage.clear("meLembreIdentificador");
    localStorage.clear("meLembreEmpresa");
    http.apiCore.defaults.headers.common["Authentication-Token"] = null;
    http.apiEmpresa.defaults.headers.common["Authentication-Token"] = null;
    Sentry.setUser(null);
  },
  verificaAceiteTermos: function verificaAceiteTermos(_ref5) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _state$cliente;
      var state;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            state = _ref5.state;
            return _context4.a(2, !!((_state$cliente = state.cliente) !== null && _state$cliente !== void 0 && _state$cliente.aceitou_termos_uso));
        }
      }, _callee4);
    }))();
  },
  registraAceiteTermosUso: function registraAceiteTermosUso() {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var payload;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            payload = {};
            _context5.n = 1;
            return termosService.aceitar(payload);
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }))();
  },
  pegaTermosAtual: function pegaTermosAtual(_ref6) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var dispatch;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            dispatch = _ref6.dispatch;
            return _context7.a(2, new Promise(/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(resolve, reject) {
                var _yield$termosService$, data, termosEPolitica, _t5;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      _context6.p = 0;
                      _context6.n = 1;
                      return termosService.atual();
                    case 1:
                      _yield$termosService$ = _context6.v;
                      data = _yield$termosService$.data;
                      _context6.n = 2;
                      return dispatch("transformaUrlsTermos", data);
                    case 2:
                      termosEPolitica = _context6.v;
                      resolve(termosEPolitica);
                      _context6.n = 4;
                      break;
                    case 3:
                      _context6.p = 3;
                      _t5 = _context6.v;
                      reject(_t5);
                      console.debug("falha ao pegar termos uso");
                    case 4:
                      return _context6.a(2);
                  }
                }, _callee6, null, [[0, 3]]);
              }));
              return function (_x6, _x7) {
                return _ref7.apply(this, arguments);
              };
            }()));
        }
      }, _callee7);
    }))();
  },
  transformaUrlsTermos: function transformaUrlsTermos(_ref8, data) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            _objectDestructuringEmpty(_ref8);
            return _context9.a(2, new Promise(/*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
                var _yield$http$apiCore$g, politica, _yield$http$apiCore$g2, termos;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _context8.n = 1;
                      return http.apiCore.get(data.url_politica_de_privacidade);
                    case 1:
                      _yield$http$apiCore$g = _context8.v;
                      politica = _yield$http$apiCore$g.data;
                      _context8.n = 2;
                      return http.apiCore.get(data.url_termos_de_uso);
                    case 2:
                      _yield$http$apiCore$g2 = _context8.v;
                      termos = _yield$http$apiCore$g2.data;
                      res({
                        politica: politica,
                        termos: termos
                      });
                    case 3:
                      return _context8.a(2);
                  }
                }, _callee8);
              }));
              return function (_x8) {
                return _ref9.apply(this, arguments);
              };
            }()));
        }
      }, _callee9);
    }))();
  },
  atualizarTema: function atualizarTema(_ref0, tema) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var chave;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            _objectDestructuringEmpty(_ref0);
            tema = tema || {};
            console.debug("Atualizando tema:", tema);
            for (chave in tema) {
              vuetify.framework.theme.themes.light[chave] = tema[chave];
            }
          case 1:
            return _context0.a(2);
        }
      }, _callee0);
    }))();
  }
};
var getters = {
  identificador: function identificador(state) {
    return state.identificador;
  },
  cliente: function cliente(state) {
    return state.cliente;
  },
  empresa: function empresa(state) {
    return state.empresa;
  },
  tema: function tema(state) {
    var _state$empresa3;
    return (_state$empresa3 = state.empresa) === null || _state$empresa3 === void 0 ? void 0 : _state$empresa3.tema;
  },
  carregandoTema: function carregandoTema(state) {
    return state.carregandoTema;
  },
  preAutenticando: function preAutenticando(state) {
    return state.preAutenticando;
  }
};
function atualizarTema(tema) {
  tema = tema || {};
  console.debug("Atualizando tema:", tema);
  for (var chave in tema) {
    vuetify.framework.theme.themes.light[chave] = tema[chave];
  }
}
atualizarTema(state.empresa.tema);
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};